import React from 'react'
import '../css/Home.css'
import HomeBody from './HomeBody'
import Helmet from 'react-helmet'

function Home({ setPathName }) {
    setPathName(window.location.pathname)
    return (
        <div className="home">
            <Helmet>

                <title>Shakthi's Portfolio</title>
                <meta name="description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer. 
A student of SASTRA Deemed to be University." />
                <meta name="google-site-verification" content="Iw5fniSyefKh1MwUJCfIgMUX_5Avtj3MszSUm0CUBbI" />
                <meta name="keywords" content="shakthi ganesh r, shakthi ganesh sastra, shakthi ganesh developer" />
                <meta itemprop="name" content="Shakthi's Portfolio" />
                <meta itemprop="description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer. 
A student of SASTRA Deemed to be University." />
                <meta itemprop="image" content="https://shakthi-ganesh-r-portfolio.web.app/static/media/CropImage.0880ee6a.png" />

                <meta property="og:url" content="https://shakthi-ganesh-r-portfolio.web.app" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Shakthi's Portfolio" />
                <meta property="og:description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer.
A student of SASTRA Deemed to be University." />
                <meta property="og:image" content="https://shakthi-ganesh-r-portfolio.web.app/static/media/CropImage.0880ee6a.png" />


                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Shakthi's Portfolio" />
                <meta name="twitter:description" content="Portfolio web site created by Shakthi Ganesh R, web and android app developer.
A student of SASTRA Deemed to be University." />
                <meta name="twitter:image" content="https://shakthi-ganesh-r-portfolio.web.app/static/media/CropImage.0880ee6a.png" />

            </Helmet>
            <HomeBody className='home_homebody' />
        </div>
    )
}

export default Home
